// apps/client/src/game/systems/spaces.ts (M2-T10, rev 5 item 12) — drives SpaceScene.update for the current interior.
import type { ExtSystem } from '../game';

/** Per-frame work for the current interior (curator, aquarium fish, a villager in their room). Interiors used to hang this on
 *  onBeforeRender, which three.js never calls for a Group, so nothing moved. Runs in the fixed-step 'animation' slot. */
export const system: ExtSystem = {
  slot: 'animation',
  create(game) {
    return { name: 'animation', update: (frame) => game.scenes.current?.update?.(frame.dt, frame.now) };
  },
};
